import { useMemo } from "react";
import { useColumns as useTimeSheetTableColumns } from "../../../../TimeSheet/components/TimeSheetTable/useColumns";
import { useCustomFields } from "../../../CustomFields/context";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import { useAllowedColumns } from "./useAllowedColumns";
import { toConfig } from "../helpers";

export const useHiddenColumns = () => {
    const { groups } = useGroups();
    const { timesheetCustomFields } = useCustomFields();

    return useMemo(() => [
        "status",
        "job",
        "location",
        "scheduled-amount",
        "payCode.description",
        "pbjCode",
        ...groups.reduce((total: string[], { allocatedBy, level }: any) => {
            if (!allocatedBy) {
                return total.concat(level.replace("_", ""));
            }
            return total;
        }, []),
        ...timesheetCustomFields
            .filter(({ showByDefault }: any) => !showByDefault)
            .map(({ code }: any) => `customFields.${code}`),
    ], [timesheetCustomFields, groups]);
};

export const useColumns = () => {
    const columns = useTimeSheetTableColumns({ user: undefined, canViewRates: true } as any);
    const allowed = useAllowedColumns(columns);
    return useMemo(() => toConfig(allowed), [allowed]);
};
